import styles from './new-car-offers-menu.module.css'
import { ListSnippetItem } from '../list-snippet-item/list-snippet-item'
import { useContext } from 'react'
import { SharedUiHeaderV2Context } from '../../context/context-shared-ui-header-v2'
import { parentLinks } from '../../../data/parent-menu'
import { ExternalLink } from '../../../assets/external-link'
import {
  newCarOffersFAQs,
  newCarOffersSnippets,
} from '../../../data/new-car-offers'
import { ListWrapper } from '../list-wrapper/list-wrapper'
import { ListItem } from '../list-item/list-item'

export interface PartExchangeMenuProps {
  isMobile?: boolean
  handleFaqClick?: (value: string | null) => void
  setShouldShowMobileMenu?: () => void
}

export const NewCarOffersMenu = ({
  isMobile,
  handleFaqClick,
  setShouldShowMobileMenu,
}: PartExchangeMenuProps) => {
  const { logicStore } = useContext(SharedUiHeaderV2Context)

  const { handleTrackEvent } = logicStore

  return (
    <>
      <nav>
        {newCarOffersSnippets.map((snippet) => (
          <ListSnippetItem
            key={snippet.heading}
            isMobile={isMobile}
            heading={snippet.heading}
            snippet={snippet.snippet}
            linkText={snippet.linkText}
            href={snippet.href}
            image={snippet.image}
            alt={snippet.alt}
            {...(snippet.externalLink && { customIcon: <ExternalLink /> })}
            handleTrackEvent={() =>
              handleTrackEvent({
                name: 'click',
                category: 'mega menu',
                label: parentLinks.NEWCAROFFERS,
                action: snippet.trackingValue || snippet.trackingTitle,
                value: snippet.linkText,
              })
            }
            useReducedWidthSnippet={true}
          />
        ))}
      </nav>
      <nav className={styles.container}>
        <div className={styles.infoContainer}>
          <ListWrapper
            urlText={'Find out more'}
            href={
              'https://help.cinch.co.uk/hc/en-gb/articles/27062254452125-What-is-Marshall-Motor-Group'
            }
            handleTrackEvent={() =>
              handleTrackEvent({
                name: 'click',
                category: 'mega menu',
                label: parentLinks.NEWCAROFFERS,
                action: 'FAQ',
                value: 'Find out more',
              })
            }
          >
            <li
              key={
                'Marshall and cinch are part of Constellation Automotive Group'
              }
              className={styles.infoListItem}
            >
              <ListItem
                label={
                  'Marshall and cinch are part of Constellation Automotive Group'
                }
                href={
                  'https://help.cinch.co.uk/hc/en-gb/articles/27062254452125-What-is-Marshall-Motor-Group'
                }
                handleClickEvent={() => {
                  handleTrackEvent({
                    name: 'click',
                    category: 'mega menu',
                    label: parentLinks.NEWCAROFFERS,
                    action: 'FAQ',
                    value:
                      'Marshall and cinch are part of Constellation Automotive Group',
                  })
                  // handleFaqClick solve the scroll issue on desktop
                  handleFaqClick && handleFaqClick(null)
                  if (setShouldShowMobileMenu) {
                    setShouldShowMobileMenu()
                  }
                }}
              />
            </li>
          </ListWrapper>
        </div>
        <div className={styles.faqContainer}>
          <ListWrapper
            heading={'FAQs'}
            urlText={'Go to help and support'}
            href={'https://help.cinch.co.uk/hc/en-gb'}
            isListCard={true}
            handleTrackEvent={() =>
              handleTrackEvent({
                name: 'click',
                category: 'mega menu',
                label: parentLinks.NEWCAROFFERS,
                action: 'FAQ',
                value: 'Go to support',
              })
            }
          >
            <>
              {newCarOffersFAQs.map((faq) => (
                <li key={faq.label} className={styles.faqList}>
                  <ListItem
                    label={faq.label}
                    href={faq.href}
                    ariaLabel={faq.ariaLabel}
                    handleClickEvent={() => {
                      handleTrackEvent({
                        name: 'click',
                        category: 'mega menu',
                        label: parentLinks.NEWCAROFFERS,
                        action: 'FAQ',
                        value: faq.label,
                      })
                      // handleFaqClick solve the scroll issue on desktop
                      handleFaqClick && handleFaqClick(null)
                      if (setShouldShowMobileMenu) {
                        setShouldShowMobileMenu()
                      }
                    }}
                  />
                </li>
              ))}
            </>
          </ListWrapper>
        </div>
      </nav>
    </>
  )
}
